import Vue from "vue";
import App from "./App.vue";
import BaiduTongji from "./baidu"; // 路径根据实际情况调整
import './assets/animations.css'; // 引入动画CSS

Vue.use(BaiduTongji); // 使用插件
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount("#app");